/*
* Created on Feb 18, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useState, useEffect, useRef} from 'react';
import ic_info_svg from '../../static/img/utils/ic_sys_info.svg'
import ModalComponent from "../common/ModalComonent/ModalComponent";
import useInputHandler from "../../hook/InputHandlerHook";
// import axios from "axios";
import axios from "axios-jsonp-pro"
import useToggle from "../../hook/ToggleHook";
import SiteAdminSelectorComponent from "./SiteAdminSelectorComponent";
import SiteGoogleMapComponent from "./SiteGoogleMapComponent";
import SiteBaiduMapComponent from "./SiteBaiduMapComponent";
import TextInputComponent from "../common/Form/TextInputComponent";
import {EMAIL_FORMAT, LENGTH_FORMAT, ORGANIZATION_NAME_FORMAT, PHONE_FORMAT} from "../../service/common";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import {useRegion} from "../../context/RegionContext";
import {useOrganization} from "../../context/OrganizationContext";


const SiteCreateModalComponent = ({openModal, closeModal, doRefresh, organizationId, initData, mode='create'}) => {
    const {userProfile} = useOrganization();
    const {is_owner} = userProfile();
    const {OrganizationAPI} = useOrganizationApi();
    const {t} = useTranslation();
    const {url, getCurrentDomainRegion} = useRegion();
    const modal = useRef();

    let initial_values = {
        name: {value: initData?.name || "", error: null, required: true},
        description: {value: initData?.description || "", error: null, required: false},
        contactor: {value: initData?.contactor || "", error: null, required: true},
        contact_email: {value: initData?.contact_email || "", error: null, required: true},
        contact_phone: {value: initData?.contact_phone || "", error: null, required: false},
        timezone: {value: initData?.timezone || {listName: t('@Select timezone@')}, error: null, required: true},
        location: {
            value: {
                "lat": parseFloat(initData?.location?.lat || ""),
                "lng": parseFloat(initData?.location?.lng || ""),
                "address": initData?.location?.address || ""
            }, error: null, required: true
        },
        admin: {
            value: {
                "users": initData?.admin?.users?.map(u=>{return {id:u, email:u.email}}) || [],
                "groups": initData?.admin?.groups?.map(g=>{return {id:g, name: g.name}}) || []
            }, error: null, required: false
        }
    }
    const [map, setMap] = useState('google');
    const [open, node] = useToggle();
    const [onTimeInput, setOnTimeInput] = useState(false);
    const [timeQuery, setTimeQuery] = useState('');
    const [timezone, setTimezone] = useState([]);
    const [input, setInput] = useState(initial_values);
    const {handleInputChange} = useInputHandler(initial_values);
    const [bMap, setBMap] = useState(null);
    const [adminChangeValues, setAdminChangeValues] = useState(undefined);

    const selectTimeZone = (timezone) => {
        setInput((prevInput)=> {
            return {...prevInput, timezone: {value: timezone, error: null}}
        });
        setOnTimeInput(false);
    }

    const updateAddress = (e) => {
        setInput((prevInput) => {
            let error = '';
            if (e.target.value.length > 200) {
                error = t('@Invalid format@');
            }
            return {...prevInput, location: {value: {address: e.target.value, lat: prevInput.location.value.lat, lng: prevInput.location.value.lng}, error}}
        });
    }

    const updateLocation = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (map === 'google' && getCurrentDomainRegion() !== 'CHINA') {
                const geocoder = new window.google.maps.Geocoder();
                geocoder.geocode({address: e.target.value})
                    .then(data => {
                        const geo = data.results?.[0].geometry;
                        if (geo) {
                            setInput((prevInput) => {
                                return {...prevInput, location: {value: {address: e.target.value, lat: geo.location.lat(), lng: geo.location.lng()}}}
                            });
                        }
                    }).catch(error=>console.log(error));
            }
            else if (map === 'baidu') {
                const getCurrentLocation = () => {
                    const geo = new bMap.Geolocation();
                    geo.enableSDKLocation();
                    geo.getCurrentPosition((resp) => {
                        console.log(resp)
                        setInput((prevInput) => {
                            return {
                                ...prevInput,
                                location: {value: {address: e.target.value, lat: resp?.latitude, lng: resp?.longitude}}
                            }
                        });
                    });
                }
                if (bMap) {
                    axios.jsonp(`https://api.map.baidu.com/geocoding/v3/?address=${encodeURIComponent(input.location.value.address)}&output=json&ak=${window._env_.REACT_APP_BAIDU_MAP_AK}&callback=showLocation&extension_analys_level=1&ret_coordtype=gcj02ll`)
                        .then(data => {
                            console.log(data);
                            if (data.status === 1) {
                                getCurrentLocation();
                            }
                            setInput((prevInput) => {
                                return {...prevInput, location: {value: {address: e.target.value, lat: data.result?.location.lat, lng: data.result?.location.lng}}}
                            });
                        }).catch(error => {
                            getCurrentLocation();
                        });
                }
            }
        }
    }

    const compare = (otherArray) => {
        return (current) => otherArray.filter((other)=>other.id === current.id).length === 0;
    }

    const onSubmit = async () => {
        let data = {};
        let admin = {};
        for (const key in input) {
            data[key] = input[key].value
            if (key==='timezone') {
                if (data[key].listName === t('@Select timezone@')) {
                     setInput((prevInput)=> {
                        return {...prevInput, timezone: {value: timezone, error: "This field is required!"}}
                     });
                     throw new Error(t('@Required fields are missing.@'));
                }
            }
            if (key === 'location') {
                data[key].lat = data[key].lat.toString();
                data[key].lng = data[key].lng.toString();
            }
            else if (key === 'admin') {
                data[key].users = data[key].users.map(u=>{return {id: u.id, email: u.email}});
                data[key].groups= data[key].groups.map(g=>{return {id: g.organization_group_id, name: g.name}});
                if (initData) {
                    // for update needs to separate add and remove
                    admin['add'] = {
                        users: data[key].users.filter(compare(initial_values.admin.value.users)),
                        groups: data[key].groups.filter(compare(initial_values.admin.value.groups))
                    }
                    admin['remove'] = {
                        users: initial_values.admin.value.users.filter(compare(data[key].users)).map(u=>{
                            if (adminChangeValues?.user && adminChangeValues?.user[u.id]) {
                                return {id: u.id, email: adminChangeValues.user[u.id].email}
                            }
                            return u;
                        }),
                        groups: initial_values.admin.value.groups.filter(compare(data[key].groups)).map(g=>{
                            if (adminChangeValues?.group && adminChangeValues?.group[g.id]) {
                                return {id: g.id, name: adminChangeValues.group[g.id].name}
                            }
                            return g;
                        })
                    }
                    data[key] = admin
                }
            }
        }

        if (!initData) {
            try {
                await OrganizationAPI.post(`organization/${organizationId}/site`, null, data);
                doRefresh((prevVal) => prevVal + 1);
                closeModal();
            } catch (err) {
                const message = err.response?.data?.message || err.message;
                const code = err.response?.data?.code? err.response.data.code : err.code;
                modal.current.alert(true, 'error', code, message)
            }
            // OrganizationAPI.post(`organization/${organizationId}/site`, null, data)
            //     .then(() => {
            //         doRefresh((prevVal)=>prevVal+1);
            //         closeModal();
            //     }).catch(error=>{console.log(error)});
        }
        else {
            try {
                await OrganizationAPI.put(`organization/${organizationId}/site/${initData.organization_site_id}`, null, data)
                doRefresh((prevVal)=>prevVal+1);
                closeModal();
            } catch (err) {
                modal.current.alert(true, 'error', err.response.data.code, err.response.data.message)
            }

            // OrganizationAPI.put(`organization/${organizationId}/site/${initData.organization_site_id}`, null, data)
            //     .then(() => {
            //         doRefresh((prevVal)=>prevVal+1);
            //         closeModal();
            //     }).catch(error=>{console.log(error)});
        }
    }

    useEffect(() => {
        axios.get(`${url.get_oauth_api_url()}/v1.2/timezone_list`).then((resp)=>{
            setTimezone(resp.data?.result ?? []);
        });
        setInput(initial_values)
    }, []);

    useEffect(()=>{
        if (openModal === false) {
            setInput(()=> {
                return({...input, ...initial_values})
            });
        }
        // setInput(initial_values)
    }, [openModal]);

    if (!is_owner) return null;

    return (
        <ModalComponent isOpen={openModal} onClose={closeModal} onSubmit={onSubmit} ref={modal}
                        title={`${mode==='create' ? t('@Create@') : t('@Edit@')} ${t('@Site@')}`} modalSize={'large'}
                        okText={`${mode==='create' ? t('@Create@') : t('@Apply@')}`} input={input}>
            <div className="dialog-content">
                <form>
                    <TextInputComponent label={t('@Site Name@')} field_name={'name'} input={input} setInput={setInput} place_holder={t('@Enter a site name (maximum 50 characters)@')} format={LENGTH_FORMAT(50)}/>
                    <TextInputComponent label={t('@Description@')} field_name={'description'} input={input} setInput={setInput} place_holder={t('@Enter a description@')} format={LENGTH_FORMAT(250)}/>
                    <TextInputComponent label={t('@Contactor@')} field_name={'contactor'} input={input} setInput={setInput} place_holder={t('@Enter a contactor@')} format={LENGTH_FORMAT(100)}/>
                    <TextInputComponent label={t('@Contact Email@')} field_name={'contact_email'} input={input} setInput={setInput} place_holder={t('@Enter a email address@')} format={EMAIL_FORMAT}/>
                    <TextInputComponent label={t('@Contact Phone@')} field_name={'contact_phone'} input={input} setInput={setInput} place_holder={t('@Enter a phone number@')} format={PHONE_FORMAT}/>
                    <div className="form-row">
                        <div className="form-label"><label>{t('@Site Administrators@')}</label></div>
                        {input.admin && <SiteAdminSelectorComponent input={input} setInput={setInput} handleInputChange={handleInputChange} setAdminChangeValues={setAdminChangeValues}/>}
                    </div>
                    <div className="form-row">
                        <div className="form-label required"><label>{t('@Timezone@')}</label></div>
                        <div className="form-field">
                            <div className="comp-select" >
                                <div className={`select-toggle {(!input.timezone) || (input?.timezone?.error == null) ? '' : 'invalid'}`} ref={node}>
                                    <span className="select-label">{input.timezone?.value.listName}</span>
                                </div>
                                <div className={`comp-dropdown comp-select-dropdown ${open==='show' || onTimeInput ? 'show' : 'hide'}`}>
                                    <ul className="comp-dropdown-menu !max-w-40vw">
                                        <li className="section func-section contacts-filter" >
                                            <div className="filter-bar">
                                                <input type="text" placeholder={t('@Search@')} className="ng-pristine ng-untouched"
                                                       onFocus={e=>setOnTimeInput(true)}
                                                       onChange={e=>{setTimeQuery(e.target.value);}} />
                                            </div>
                                        </li>

                                        <li className="section add-scroll">
                                            {
                                                timezone.length>0 &&
                                                timezone.filter(t=>t.listName.match(new RegExp(timeQuery, 'i'))).map((t, index)=><div className="section-items selection" key={index} onClick={()=>selectTimeZone(t)}>{t.listName}</div>)
                                            }
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={`error-msg ${input.timezone.error? '': 'hide'}`}>{input.timezone.error}</div>
                        </div>
                    </div>
                    <div className="form-row site-form-row">
                        <div className="form-label"><label>{t('@Location@')}</label></div>
                        <div className="form-field">
                            <input type="text" placeholder={t('@Enter a address, place name or coordinates@')}
                                   value={input.location?.value.address || ''}
                                   onChange={(e) => updateAddress(e)}
                                   onKeyPress={(e) => updateLocation(e)}/>
                            <div className={`error-msg ${input.location.error ? '' : 'hide'}`}>{input.location.error}</div>
                            <div className="map-group !mt-10">
                                <div className="map-switch">
                                    <ul>
                                        {getCurrentDomainRegion() !== 'CHINA' &&
                                            <li className={`switch-item ${map === 'google' ? 'active' : ''}`}
                                                onClick={() => setMap('google')}>Google Map</li>
                                        }
                                        {getCurrentDomainRegion() !== 'CHINA' &&
                                            <li className="switch-divide"/>
                                        }
                                        <li className={`switch-item ${map === 'baidu' ? 'active' : ''}`} onClick={() => setMap('baidu')}>Baidu Map</li>
                                    </ul>
                                </div>
                                <div className="map-canvas">
                                    {/*// <!-- Error -->*/}
                                    <div className="map-gio-error hide">
                                        <div className="gio-error-content">{t('@Unable to locate current address@')}</div>
                                    </div>
                                    {/*// <!-- Insert map code here -->*/}
                                    {map === 'google' && getCurrentDomainRegion() !== 'CHINA' && <SiteGoogleMapComponent
                                        input={input}
                                        setInput={setInput}
                                        isMarkerShown={true}
                                        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${window._env_.REACT_APP_GOOGLE_MAP_KEY}&v=3.exp&libraries=places`}
                                        loadingElement={<div style={{height: `100%`}}/>}
                                        containerElement={<div style={{height: `100%`}}/>}
                                        mapElement={<div style={{height: `100%`}}/>}/>}

                                    {map === 'baidu' && <SiteBaiduMapComponent input={input} setInput={setInput} bMap={bMap} setBMap={setBMap}/>}
                                </div>
                            </div>
                            <div className="text-remind info-hint !mt-10 color-indigo">
                                <span className="ic-info-inline"><img src={ic_info_svg} alt=""/></span>
                                <span>{t('@Right click on the map below to drop a pin to get the address.@')}</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </ModalComponent>
    );
};

export default SiteCreateModalComponent;

